import { Button } from "@newsela/angelou";
import {
  actionNames,
  actionPrefixes,
  objectTypes,
  withTrackEvent,
} from "@newsela/snitch";

import { useExportablesContext } from "@/components/AIComponents/ExportablesModal/ExportablesContextProvider/useExportablesContext";
import {
  hideOnTabletAndUpCss,
  endAlignedButtonCss,
} from "./ExportablesModalFooter.styles";

const ButtonWithTrackEvent = withTrackEvent(Button);

const MobileActions = () => {
  const { renderOnMobile, handleModalClose } = useExportablesContext();

  return (
    <>
      {!renderOnMobile && (
        <div
          css={[endAlignedButtonCss, hideOnTabletAndUpCss]}
          data-testid="footer-button"
        >
          <ButtonWithTrackEvent
            flavor={Button.flavors.secondary}
            onClick={handleModalClose}
            dataProps={{ "data-qa-selector": "close-graphic-organizer-modal" }}
            objectType={objectTypes.generatedTextAsset}
            actionPrefix={actionPrefixes.cancel}
            actionName={actionNames.hide}
            streamProperties={{
              description: "Close Graphic Organizer modal",
            }}
          >
            Close
          </ButtonWithTrackEvent>
        </div>
      )}
    </>
  );
};

export default MobileActions;
